<template>
  <v-card class="mt-0 flex d-flex flex-column" outlined :loading="loading">
    <v-card-title class="justify-center">
      Activity Revenue (MTD)
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
        </template>
        <span
          >Value of all activity so far this month. This is not billed
          revenue.</span
        >
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-simple-table>
        <tbody>
          <tr>
            <td>Premium Calls</td>
            <td>{{ premiumCallsTotal | dollarsCents }}</td>
          </tr>
          <tr>
            <td>Premium Clicks</td>
            <td>{{ premiumClicksTotal | dollarsCents }}</td>
          </tr>
          <tr>
            <td>Helpline USA</td>
            <td>{{ helplineUSARevenue | dollarsCents }}</td>
          </tr>
          <tr>
            <td>Helpline Canada</td>
            <td>{{ helplineCanadaRevenue | dollarsCents }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { getActivityRevenueGraph } from "../../api/report";
import { startOfTomorrow, startOfMonth } from "date-fns";

export default {
  name: "ActivityRevenue",

  data() {
    return {
      premiumClicksTotal: 0,
      premiumCallsTotal: 0,
      helplineUSARevenue: 0,
      helplineCanadaRevenue: 0,
      loading: false
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData(
      startDate = startOfMonth(new Date()),
      endDate = startOfTomorrow()
    ) {
      try {
        this.loading = true;

        const result = await getActivityRevenueGraph(startDate, endDate);
        if (result.items.length == 2) {
          console.error("too many results", result.items);
        } else if (result.items.length == 1) {
          this.premiumCallsTotal = result.items[0].calls;
          this.premiumClicksTotal = result.items[0].clicks;
          this.helplineUSARevenue = result.items[0].helplineUSA;
          this.helplineCanadaRevenue = result.items[0].helplineCA;
        }
      } catch (e) {
        console.error("ERROR IN ACTIVITY REVENUE", e);
      }

      this.loading = false;
    }
  }
};
</script>
